import { i18n } from '@js/i18n'

export default {
  form: {
    country: '',
    city: '',
    street: '',
    zipCode: ''
  },
  rows: [
    [
      {
        "heading": i18n.kyc_submit_legal_address()
      }
    ],
    [
      {
        "model": "country",
        "name": "country",
        "id":  "kyc-country",
        "label": i18n.lbl_country(),
        "field": "select",
        "required": true,
        "values": "countries",
        "validate": "required"
      }
    ],
    [
      {
        "model": "city",
        "name": "city",
        "id":  "kyc-city",
        "label": i18n.lbl_city(),
        "field": "text",
        "required": true,
        "validate": "required"
      }
    ],
    [
      {
        "model": "street",
        "name": "street",
        "id":  "kyc-street",
        "required": true,
        "label": i18n.lbl_street_name(),
        "field": "text",
        "validate": "required|max:45"
      }
    ],
    [
      {
        "model": "zipCode",
        "name": "zip-code",
        "id":  "kyc-zip-code",
        "label": i18n.lbl_zip_code(),
        "field": "text",
        "required": true,
        "validate": "required|max:20"
      }
    ]
  ]
}



// WEBPACK FOOTER //
// ./src/vue/app/verification/spec/syndicate/step-2.address.schema.js